import { createContext, ReactNode, useContext, useMemo } from 'react'
import { Nullable } from '@/types/nullable'
import { EnterpriseIdentity } from '@/types/schema/api/enterprise-identity'

interface EnterpriseIdentityContextProps {
  enterpriseIdentity: Nullable<EnterpriseIdentity>
}

const enterpriseIdentityContext = createContext<EnterpriseIdentityContextProps>(
  {
    enterpriseIdentity: null,
  },
)

type EnterpriseIdentityProviderProps = {
  enterpriseIdentity: Nullable<EnterpriseIdentity>
  children: ReactNode
}

export const EnterpriseIdentityProvider = ({
  enterpriseIdentity,
  children,
}: EnterpriseIdentityProviderProps): ReactNode => {
  const value = useMemo(() => ({ enterpriseIdentity }), [enterpriseIdentity])

  return (
    <enterpriseIdentityContext.Provider value={value}>
      {children}
    </enterpriseIdentityContext.Provider>
  )
}

export const useEnterpriseIdentity = (): Nullable<EnterpriseIdentity> => {
  const context = useContext(enterpriseIdentityContext)
  if (!context) {
    throw new Error(
      'useEnterpriseIdentity must be used within EnterpriseIdentityProvider',
    )
  }
  return context.enterpriseIdentity
}
